export default "__VITE_ASSET__Boi3xNBT__"